import _tokens from './tokens.js'

import { UnitType } from '@exodus/currency'

const name = 'neo'
const feeAssetName = 'neogas'
const displayName = 'NEO'
const ticker = 'NEO'
const displayTicker = 'NEO'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#01E397'
const gradientColors = ['#01E397', '#0DD190']
const gradientCoords = { x1: '0%', y1: '0%', x2: '102%', y2: '101%' }
const chainBadgeColors = gradientColors

const units = {
  NEO: 0,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.o3.network/addresses/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.o3.network/transactions/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'NEO is a cryptocurrency and smart contract platform designed to build scalable decentralized applications.',
  reddit: 'https://www.reddit.com/r/NEO/',
  twitter: 'https://twitter.com/neo_blockchain',
  website: 'https://neo.org/',
}
const contract = {
  id: 'NEO',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  contract,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  feeAssetName,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export const tokens = _tokens.map((token) => {
  return {
    ...token,
    // name,
    // contract,
    // displayName,
    // ticker,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    // units
    assetType: 'NEO_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    currency: UnitType.create(token.units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    feeAssetName,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    toString: () => token.name,
  }
})

export default [asset, ...tokens]
